import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';
import Footer from '../../CommonComponent/Footer/footer';
import ABComponent from './PageComponent/ABComponent';

function About() {
  useMeta({
    title: 'About Us | Callistus Blinds',
    description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
    canonical: 'https://callistusblinds.com/about-us/',
    og: {
      locale: 'en_US',
      type: 'article',
      title: 'About Us | Callistus Blinds',
      description:
        'Callistus is a multinational brand which is supported by entrepreneurs with vast experience in various countries for more than 25 years in the Window Covering Industry. Callistus Window Fashions has carved a niche by combining innovation, research, quality, technology and experience giving birth to the largest range of Blinds in the world which are corresponded with the highest options of excellent Operating Systems and huge array of complementing fabrics.',
      url: 'https://callistusblinds.com/about-us/',
      site_name: 'Callistus Blinds',
    },
  });

  return (
    <div>
      <Navbar />
      <NotificationBar />
      <ABComponent />
      <Footer />
    </div>
  );
}

export default About;
